<template>
  <div>
    <v-card>
      <!-- Loader/Freeze overlay khi upload -->
      <v-dialog v-model="scanUploading" persistent width="400">
        <v-card class="pa-6 text-center">
          <v-progress-linear
            :value="scanUploadProgress"
            height="10"
            color="primary"
            striped
          ></v-progress-linear>
          <div class="mt-4">Đang tải ảnh scan: {{ scanUploadProgress }}%</div>
          <div class="mt-2 text-caption">Vui lòng đợi quá trình hoàn tất...</div>
        </v-card>
      </v-dialog>

      <div class="pa-6">
        <!-- Nút tải ảnh scan + hiển thị số ảnh lỗi -->
        <div class="full-width text-end mb-6 d-flex align-center justify-end">
          <v-btn color="primary" @click="triggerScanUpload">
            Tải ảnh scan phiếu trắc nghiệm
          </v-btn>
          <span class="ml-4" v-if="unrecognizedCount > 0" style="color:red;">
            {{ unrecognizedCount }} ảnh không lấy được thông tin
          </span>
          <input
            ref="scanUploader"
            type="file"
            class="d-none"
            accept="image/*"
            multiple
            @change="onScanFileChanged"
          />
        </div>

        <!-- Bảng điểm -->
        <v-card outlined>
          <v-data-table
            item-key="examCode"
            :headers="headers"
            :loading="loading"
            :items="marks"
            :items-per-page="-1"
            :disable-sort="$vuetify.breakpoint.smAndDown"
            hide-default-footer
            fixed-header
          >
            <template v-slot:[`item.examCode`]="{ item }">{{ item.examCode || '-' }}</template>
            <template v-slot:[`item.value`]="{ item }">{{ item.value || '-' }}</template>
            <template v-slot:[`item.scanImages`]="{ item }">
              <v-btn
                v-if="item.scanImages && item.scanImages.length"
                icon
                @click="openScanImagePopup(item.scanImages)"
              >
                <v-icon>mdi-image</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.correctCount`]="{ item }">{{ item.correctCount || '-' }}</template>
            <template v-slot:[`item.wrongCount`]="{ item }">{{ item.wrongCount || '-' }}</template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon small color="red" @click="deleteMark(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn icon small color="blue" @click="editScanImage(item)">
                <v-icon>mdi-image-edit</v-icon>
              </v-btn>
              <v-btn icon small color="green" @click="recheckMark(item)">
                <v-icon>mdi-pencil-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>

        <!-- Popup xem ảnh -->
        <v-dialog v-model="showImagePopup" max-width="600">
          <v-card>
            <v-toolbar flat color="primary" dark>
              <v-toolbar-title>Ảnh chấm</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="showImagePopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-carousel hide-delimiter-background height="400">
                <v-carousel-item v-for="(img, index) in popupImages" :key="index">
                  <v-img :src="img" contain  height="400"></v-img>
                </v-carousel-item>
              </v-carousel>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ExamMark } from '@/plugins/api'

export default {
  props: ['query', 'subject', 'exam'],
  data() {
    return {
      loading: false,
      headers: [],
      marks: [],
      scanUploading: false,
      scanUploadProgress: 0,
      unrecognizedCount: 0,   // số ảnh không lấy được thông tin
      showImagePopup: false,
      popupImages: []
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  methods: {
    ...mapActions('examMark', ['fetchMarks']),
    ...mapActions('examMarkOmr', ['uploadImage', 'calMore']),

    async refresh() {
      this.loading = true
      try {
        this.marks = await this.fetchMarks({ ...this.query, status: 'present', _sort: 'examCode:ASC', _limit: -1 })
      } catch (e) {
        this.$alert.error('Lỗi load thông tin học sinh')
      } finally {
        this.loading = false
      }
    },

    async saveMarks() {
      this.$loading.active = true
      this.loading = true
      try {
        await ExamMark.updateSubjectGrades({
          marks: this.marks,
          subject: this.marks[0].subject,
          exam: this.marks[0].exam
        })
        this.$alert.success('Nhập điểm thành công')
      } catch (e) {
        this.$alert.error(e)
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },

    triggerScanUpload() {
      this.$refs.scanUploader.click()
    },

    async onScanFileChanged(e) {
  const files = Array.from(e.target.files)
  if (!files.length) return
  this.scanUploading = true
  this.scanUploadProgress = 0
  this.unrecognizedCount = 0   // reset cho mỗi lần upload

  const totalFiles = files.length
  let uploadedCount = 0
  const imagesPayload = []

  // Upload từng file
  for (const file of files) {
    try {
      const formData = new FormData()
      formData.append('files', file)
      const res = await this.uploadImage(formData)
      const url = res[0].url
      const key = file.name
      imagesPayload.push({ url, k: key })

      uploadedCount++
      this.scanUploadProgress = Math.round((uploadedCount / totalFiles) * 50)
    } catch (err) {
      this.$alert.error(`Lỗi upload ảnh: ${file.name}`)
    }
  }

  try {
    const result = await this.calMore({
      key: 'u!LtraS3cr3tK3y',
      images: imagesPayload,
      subjectGroup: this.query.subjectGroup,
      exam: this.query.exam
    })

    // xử lý kết quả
    result.forEach(r => {
      const payloadItem = imagesPayload.find(i => i.k === r.k)
      if (payloadItem) {
        if (r.sbd) {
          this.processScanResult(r, payloadItem.url)
        } else {
          // ảnh không nhận diện được sbd => tính số lượng lỗi
          this.unrecognizedCount++
        }
      }
    })

    this.scanUploadProgress = 100

    // Lưu tự động sau khi scan xong
    await this.saveMarks()

  } catch (err) {
    console.log(err)
    this.$alert.error('Lỗi scan OMR')
  } finally {
    this.scanUploading = false
  }

  this.$refs.scanUploader.value = null
},


    processScanResult(result, imageUrl) {
      let student = this.marks.find(s => s.examCode === result.sbd)
      if (!student) {
        student = { examCode: result.sbd, scanImages: [], correctCount: 0, wrongCount: 0, value: null }
        // this.marks.push(student)
      }

      student.scanImages = student.scanImages || []
      if (!student.scanImages.includes(imageUrl)) student.scanImages.push(imageUrl)

      const calcScore = part => Object.values(part || {}).reduce((acc, v) => acc + v / 100, 0)
      student.value = calcScore(result.p1) + calcScore(result.p2) + calcScore(result.p3)

      const countQuestions = part => Object.values(part || {}).reduce((acc, v) => ({
        correct: acc.correct + (v > 0 ? 1 : 0),
        wrong: acc.wrong + (v === 0 ? 1 : 0)
      }), { correct: 0, wrong: 0 })

      const p1Count = countQuestions(result.p1)
      const p2Count = countQuestions(result.p2)
      const p3Count = countQuestions(result.p3)

      student.correctCount = p1Count.correct + p2Count.correct + p3Count.correct
      student.wrongCount = p1Count.wrong + p2Count.wrong + p3Count.wrong
    },

    openScanImagePopup(images) {
      this.popupImages = images
      this.showImagePopup = true
    },

    deleteMark(item) {
      if (!item) return
      const codeToDelete = item.examCode || item.k
      if (!codeToDelete) return
      this.marks = this.marks.filter(m => m.examCode !== codeToDelete)
    },

    editScanImage(item) {
      if (item.scanImages && item.scanImages.length) this.openScanImagePopup(item.scanImages)
    },

    recheckMark(item) {
      if (!item || !item.student) return
      this.$alert.info(`Chấm lại học sinh ${item.student.name}`)
    }
  },

  watch: {
    query: { immediate: true, handler(newVal) { if (newVal) this.refresh() } }
  },

  created() {
    this.headers = [
      { text: 'SBD', value: 'examCode' },
      { text: 'Học sinh', value: 'student.name' },
      { text: 'Lớp', value: 'student.data.studentClass' },
      { text: 'Ảnh chấm', value: 'scanImages' },
      { text: 'Số câu đúng', value: 'correctCount' },
      { text: 'Số câu sai', value: 'wrongCount' },
      { text: 'Điểm', value: 'value' },
      { text: 'Thao tác', value: 'actions' }
    ]
  }
}
</script>
